// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-sr-arrow[data-v-8d50a7d4]{display:flex}.frisbuy-sr-arrow--top svg[data-v-8d50a7d4]{transform:rotate(90deg)}.frisbuy-sr-arrow--right svg[data-v-8d50a7d4]{transform:rotate(.5turn)}.frisbuy-sr-arrow--bottom svg[data-v-8d50a7d4]{transform:rotate(-90deg)}.frisbuy-sr-arrow--left svg[data-v-8d50a7d4]{transform:rotate(0)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
